import React from 'react';
import PropTypes from 'prop-types';
import ListSubheader from '@material-ui/core/ListSubheader';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';
import { withStyles } from '@material-ui/core/styles';
import { FormattedMessage } from 'react-intl';

import messages from '../messagesManageAccounts';
import styles from './accountGroupStyles';

function Permissions(
    {
        addOrderAllowed,
        classes,
        onAddOrderAllowedChange,
    },
) {
    return (
        <>
            <ListSubheader className={classes.subHeader}>
                <FormattedMessage {...messages.lblGroupPermissions} />
            </ListSubheader>
            <FormControlLabel
                control={(
                    <Switch
                        id="srtBookingAddOrderAllowed"
                        checked={addOrderAllowed}
                        onChange={onAddOrderAllowedChange}
                    />
                )}
                label={<FormattedMessage {...messages.lblGroupAddOrderAllowed} />}
                labelPlacement="start"
                className={classes.label}
            />
        </>
    );
}

Permissions.propTypes = {
    addOrderAllowed: PropTypes.bool,
    onAddOrderAllowedChange: PropTypes.func.isRequired,
    classes: PropTypes.object.isRequired,
};

export { Permissions as PermissionsAlias };
export default withStyles(styles)(Permissions);
